export default __webpack_public_path__ + "static/case-3-hero-0cfe0472b54163de0191f77ba220fc7c.png";